import 'rxjs/add/observable/of';
import { Injectable } from '@angular/core';
import { GetBlacklistAction } from '../blacklist/blacklist.actions';
import 'rxjs/add/operator/withLatestFrom';
import { DataSourceUtils } from '../../shared/utils/data-source-utils';
import { getBlacklistSelector, getBlacklistTotalSelector } from '../blacklist/blacklist.reducer';
import { Blacklist, BlacklistRequest } from '../blacklist/blacklist';
import { DefaultParams } from '../blacklist/blacklist.config';

@Injectable()
export class BlacklistTableDataSource extends DataSourceUtils<Blacklist> {
  protected params: BlacklistRequest;

  update() {
    this.store.dispatch(new GetBlacklistAction(this.params));
  }

  onConnect() {
    this.params = new DefaultParams();
    return this.store.select(getBlacklistSelector).withLatestFrom(this.store.select(getBlacklistTotalSelector));
  }
}
